import React, { Component } from 'react';
import Header from '../components/Header';
import Video from '../components/Video';
import Pricing from '../components/Pricing';
import Footer from '../components/Footer';
// import { NavLink } from 'react-router-dom';

import './Home.css';

class Home extends Component {
    render() {

        // let alertClick = () => {
        //     let alertButton = document.getElementById('alertButton');
        //     alertButton.style.display = 'none';
        //     sessionStorage.setItem("alertShow", true);
        // };

        return (
            <div className="Home" ref={(div) => (this.appContainer = div)}>
                <Header />
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        lineHeight: '24px',
                        fontWeight: 'bold',
                    }}
                >
                    <div
                        style={{
                            width: '1072px',
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                        }}
                    >
                        <div
                            style={{
                                paddingTop: '1%',
                                paddingLeft: '9%',
                                paddingRight: '30px',
                                textShadow: '0px 2px 3px #000000',
                            }}
                        >

                        </div>
                    </div>
                </div>
                <Video videoFilename="bunker-intro-2021.mp4" />
                <Pricing />
                <Footer />
                {/* <div className='overlay-container' id="alertButton">
                    <div className="event-cta" onClick={alertClick}></div>
                </div> */}
                
            </div>
        );
    }
}

export default Home;
